import {Box, Group, Stack, Text} from "@mantine/core";
import {useTranslation} from "react-i18next";
import IconInfoCircle from "../../../assets/info-circle.svg?react";
import classes from "./ExperimentalFeatureBanner.module.css";

interface Props {
    titleKey: string;
    descriptionKey: string;
}

/**
 * Notice shown above an assistant answer that used an experimental feature.
 * A missing translation key renders as the key itself, so an unknown
 * feature key must never reach this component without a check upstream.
 */
export const ExperimentalFeatureBanner: React.FC<Props> = ({
    titleKey,
    descriptionKey,
}) => {
    const {t} = useTranslation();
    const title = t(titleKey);
    const description = t(descriptionKey);

    if (title === titleKey || description === descriptionKey) {
        return null;
    }

    return (
        <Box role="note" bg="gneis.0" py="sm" px="md" mb="lg" className={classes.banner}>
            <Group wrap="nowrap" align="flex-start" gap="sm">
                <IconInfoCircle
                    height="18px"
                    width="18px"
                    aria-hidden="true"
                    className={classes.icon}
                />
                <Stack gap={4}>
                    <Text size="md" fw={600}>
                        {title}
                    </Text>
                    <Text size="sm">{description}</Text>
                </Stack>
            </Group>
        </Box>
    );
};
